export const classTodoListCompleted = '__todo-list--completed';
